var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coupon-status-card mb-3"},[_c('h3',{staticClass:"title"},[_vm._v("訂單編號: "+_vm._s(_vm.redemptionId))])])}
var staticRenderFns = []

export { render, staticRenderFns }